import { GameSituation } from '../types/game-situation.ts'

export default function loadFormValuesByQueryString(): void {
    const qs = new URLSearchParams(window.location.search)
    const jsonString = qs.get('qs')
    const ddlType = qs.get('type')

    if (jsonString) {
        try {
            if (ddlType) {
                const select = document.querySelector<HTMLSelectElement>(
                    'select[name="ddlType"]'
                )
                if (select) {
                    select.value = ddlType
                    const selectedText =
                        select.options[select.selectedIndex]?.text
                    const label = document.getElementById('lblType')

                    if (label) {
                        label.innerHTML = selectedText
                    }
                }
            }

            // Parse the JSON into our GameSituation type
            const params: GameSituation = JSON.parse(jsonString)

            // 1. Inning + Half (Radio Buttons)
            // Note: We use optional chaining because JSON values might be null/undefined
            if (params.inning !== null && params.half) {
                const selector = `input[name="inning"][value="${params.inning}"][data-half="${params.half}"]`
                const input = document.querySelector<HTMLInputElement>(selector)
                if (input) input.checked = true
            }

            // 2. Situation (Select Dropdown)
            if (params.situation) {
                const select = document.querySelector<HTMLSelectElement>(
                    'select[name="situation"]'
                )
                if (select) select.value = params.situation
            }

            // 3. Outs / Balls / Strikes / Run Diff (Radio Buttons)
            const setRadioByValue = (
                name: string,
                value: string | number | null | undefined
            ) => {
                if (value === null || value === undefined) return
                const input = document.querySelector<HTMLInputElement>(
                    `input[name="${name}"][value="${value}"]`
                )
                if (input) input.checked = true
            }

            setRadioByValue('outs', params.outs)
            setRadioByValue('balls', params.balls)
            setRadioByValue('strikes', params.strikes)
            setRadioByValue('diff', params.run_diff)

            // 4. Runners (Data Attributes)
            // Accessing the nested 'runners' object from GameSituation
            if (params.runners) {
                const bases = ['1b', '2b', '3b'] as const
                bases.forEach((base) => {
                    const isRunnerPresent = params.runners[base]
                    const baseElement = document.getElementById(
                        `runner-${base}`
                    )

                    if (baseElement) {
                        baseElement.dataset.selected = 'false'
                        if (isRunnerPresent) {
                            baseElement.dataset.selected = 'true'
                            baseElement.setAttribute('aria-pressed', 'true')
                            baseElement.classList.add('base-selected')
                        }
                    }
                })
            }

            // 4. Perspective
            if (params.perspective && params.perspective === 'bat') {
                const checkbox = document.querySelector<HTMLInputElement>(
                    'input[name="perspective"]'
                )

                if (checkbox) {
                    checkbox.checked = true
                }
            }
        } catch (e) {
            console.error('Failed to parse game situation JSON from URL', e)
        }
    }
}
